<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="page_xiv"></a><img alt="image" src="images/f0xiv-01.jpg"/></p>
<p class="caption">Map 1. Map of South and Southeast Asia, including quake epicenter and the main tsunami-affected countries around the Indian Ocean basin.</p>
<p class="image"><a id="page_xv"></a><img alt="image" src="images/f00xv-01.jpg"/></p>
<p class="caption">Map 2. Map of Sri Lanka’s main cities; additional towns are shown on the southwest coast.<a id="page_xvi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?7f36d564